// App.js
import React, { useEffect, useRef } from "react";
import { useSetRecoilState } from "recoil";
import AppMain from "./view/main/AppMain";
import { languageAtom, UserLanguage } from "./value/AppModel";
import { Box, styled } from "@mui/material";

const CopyBox = styled(Box)({
  fontSize:'0.8rem', color:'#aaa',backgroundColor:'#002040', padding:10, borderRadius:5,
  textAlign:'center', marginTop: 40,
});

const currentUrl = window.location.href;

function App() {
  const setLanguage = useSetRecoilState(languageAtom);
  const startRef = useRef(0);

  useEffect(()=>{
    if(startRef.current === 0){

      const browserLang = navigator.language;
      if(browserLang.startsWith('ko')) {
        setLanguage({key:UserLanguage.korean.key, label: UserLanguage.korean.label});
      }
      else if(browserLang.startsWith('es')) {
        setLanguage({key:UserLanguage.spanish.key, label: UserLanguage.spanish.label});
      }
      else {
        setLanguage({key:UserLanguage.english.key, label: UserLanguage.english.label});
      }

      startRef.current++;
    }
  }, []);

  return (
    <React.Fragment>
    <AppMain />
    <CopyBox>
        Copyright (c) 2024. Labisfun, Inc., Seoul, Korea, All rights reserved.
    </CopyBox>
    </React.Fragment>
  );
}

export default App;
